<div class="filter-top-bar" #filterTopBar>
  <div class="filter-wrapper dropdown">
    <div class="d-flex justify-content-start align-items-center me-10">
      <input type="search" class="form-control table-search ps-35" placeholder="Enter your search term" [formControl]="searchFormControl" />
      <span class="position-absolute icon-search ps-10"></span>
    </div>
    <div class="filter-tabs-holder" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a
            cdkDragHandle
            class="dropdown-toggle d-flex justify-content-center align-items-center"
            role="button"
            id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
            [ngClass]="{ active: isFilterActive(filter) }">
            {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">&nbsp;({{ peekValue | truncate: 4 }})</span>
          </a>

          <form [formGroup]="form">
            <div
              *ngIf="filter.filterKey === 'enabled'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onClickedEnabled()">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('enabled')?.value === true" />
                  </div>
                  <span>Enabled</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onClickDisabled()">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('enabled')?.value === false" />
                  </div>
                  <span>Disabled</span>
                </div>
              </div>
            </div>

            @if (filter.filterKey === 'lastTopUpRanges') {
              <div class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="filter-lastTopUpRanges">
                <div class="mx-10">
                  @for (range of lastTopUpRanges; track range.id) {
                    <label class="top-up-range d-flex justify-content-start align-items-center gap-10 my-10 cp">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="(form.get('lastTopUpRanges')?.value || []).includes(range.id)"
                        (change)="onChangeListSelection('lastTopUpRanges', range.id)" />
                      <span>{{ range.label }}</span>
                    </label>
                  }
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center mx-10">
                  <span class="text-neutral-n7" role="status">{{ (form.get('lastTopUpRanges')?.value || []).length }} selected</span>
                  <button type="button" class="btn" (click)="onClear(filter.filterKey)">Clear</button>
                </div>
              </div>
            }

            @if (filter.filterKey === 'lastTestRequestedGroups') {
              <div class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="filter-lastTestRequestedGroups">
                <div class="mx-10">
                  @for (option of lastTestRequestedOptions; track option.id) {
                    <label class="last-test-requested-group d-flex justify-content-start align-items-center gap-10 my-10 cp">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="(form.get('lastTestRequestedGroups')?.value || []).includes(option.id)"
                        (change)="onChangeListSelection('lastTestRequestedGroups', option.id)" />
                      <span>{{ option.label }}</span>
                    </label>
                  }
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center mx-10">
                  <span class="text-neutral-n7" role="status">{{ (form.get('lastTestRequestedGroups')?.value || []).length }} selected</span>
                  <button type="button" class="btn" (click)="onClear(filter.filterKey)">Clear</button>
                </div>
              </div>
            }

            @if (filter.filterKey === 'agreementStatus') {
              <div class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="fiter-{{ filter.filterKey }}">
                <div class="mx-10">
                  @for (agreementStatus of agreementStatuses; track agreementStatus.id) {
                    <div
                      tabindex="0"
                      (keyup.enter)="onChangeAgreementStatusSelection(agreementStatus.id)"
                      class="d-flex justify-content-start align-items-center gap-10 my-10 cp"
                      (click)="onChangeAgreementStatusSelection(agreementStatus.id)">
                      <div class="input-check">
                        <input type="checkbox" class="form-check-input" [checked]="isAgreementStatusSelected(agreementStatus.id)" />
                      </div>
                      <span>{{ agreementStatus.label }}</span>
                    </div>
                  }
                </div>
              </div>
            }

            @if (filter.filterKey === 'rankingIndexes') {
              <div class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="filter-rankingIndexes">
                <div class="mx-10">
                  @for (rankingIndex of rankingIndexes; track rankingIndex) {
                    <label class="d-flex justify-content-start align-items-center gap-10 my-10 cp">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="(form.get('rankingIndexes')?.value || []).includes(rankingIndex)"
                        (change)="onChangeListSelection('rankingIndexes', rankingIndex)" />
                      <span>{{ rankingIndex }}</span>
                    </label>
                  }
                </div>
                <hr />
                <div class="d-flex justify-content-between align-items-center mx-10">
                  <span class="text-neutral-n7" role="status">{{ (form.get('rankingIndexes')?.value || []).length }} selected</span>
                  <button type="button" class="btn" (click)="onClear(filter.filterKey)">Clear</button>
                </div>
              </div>
            }

            <div
              *ngIf="filter.filterKey === 'roles'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div
                  *ngFor="let role of roles"
                  class="role-item d-flex justify-content-start align-items-center gap-10 my-10 cp"
                  (click)="onChangeRoleSelection(role)">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="role.isSelected" />
                  </div>
                  <i [ngClass]="getIconForRole(role.id)"></i>
                  <span>{{ role.label }}</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'owner'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="owner" class="form-control owner-input" placeholder="Enter owner email or username" />
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'company'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="company" class="form-control company-input" placeholder="Enter company name" />
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'externalUserId'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="externalUserId" class="form-control company-input" placeholder="Enter external user ID" />
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'departmentName'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  formControlName="departmentName"
                  class="form-control department-input"
                  placeholder="Enter business unit/department" />
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'paymentType'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangePaymentSelection('PREPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('paymentType').value === 'PREPAID'" />
                  </div>
                  <span>Prepaid</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangePaymentSelection('POSTPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('paymentType').value === 'POSTPAID'" />
                  </div>
                  <span>Postpaid</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'comment'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="comment" class="form-control company-input" placeholder="Search by comment" />
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div>
      <div class="delete-area d-flex justify-content-center align-items-center" (click)="onClearAllFilter()">
        <span class="far fa-trash-alt"></span> Clear Filters
      </div>
    </div>
  </div>

  <div class="filter-right-col">
    <div class="d-flex justify-content-center align-items-center gap-10">
      <a class="btn btn-primary px-15" routerLink="/users/create">
        <span class="icon-add"></span>
        Create
      </a>
    </div>
  </div>
</div>
